import RoleNotice from "./RoleNotice";

export default RoleNotice;
